<template>
  <div class="disease-main-container">
    <ReturnButton></ReturnButton>
    <HomeButton></HomeButton>
    <div class="disease-main-content">
      <DiseaseTitle>疾病分类</DiseaseTitle>
      <div class="disease-classification">
        <div v-for="(item, index) in keshiList" :key=index class="disease-classification-element">
          <button class="disease-classification-button" @click="goKeShiPage(index)"
                  :style="' --clickedUrl: url(' + '\'' + `${setKeShiImg(item.clickedImgUrl)}` + '\'' +'); --imgUrl: url(' + '\'' + `${setKeShiImg(item.imgUrl)}` + '\'' +');'">
          </button>
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReturnButton from "@/components/ReturnButton";
import HomeButton from "@/components/HomeButton";
import DiseaseTitle from "@/components/DiseaseTitle";
import CommonData from "@/assets/js/CommonData";

export default {
  name: 'DiseaseMainPage',
  components: {
    HomeButton,
    ReturnButton,
    DiseaseTitle,
  },
  data() {
    return {
      keshiList: JSON.parse(JSON.stringify(CommonData.keshiList))
    };
  },
  methods: {
    goKeShiPage: function (index) {
      console.log(this.keshiList[index].keShiCode)
      this.$router.push({
        path: '/diseaseKeShiPage',
        query: {
          keShi: this.keshiList[index].keShiCode,
        }
      })
    },
    setKeShiImg(imgName) {
      return require(`../assets/image/diseasePage/keshi/${imgName}.png`);
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style>
.disease-main-container {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../assets/image/NormalBg.png");
  display: flex;
  flex-direction: column;
}

.disease-classification {
  display: flex;
  flex-wrap: wrap;
  margin: 9vw 3.5vw 0 3.5vw;
}

.disease-classification-element {
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3.5vw;
  font-family: "PingFang", serif;
  color: #c8c8c8;
  margin: 0 0 5.5vw 0;
}

.disease-classification-button {
  height: 12.5vw;
  width: 18.2vw;
  background-size: 100% 100%;
  background-color: transparent;
  background-image: var(--imgUrl);
  border: 0;
}

.disease-classification-button:active {
  background-image: var(--clickedUrl);
}
</style>
